import {useEffect, useState} from 'react';
import firebase from 'firebase';
import {auth, storage, db} from './firebase.js';
import EmojiPicker from 'emoji-picker-react';

function Header(props){

    const [user, setUser] = useState();
    const [progress, setProgress] = useState(0);
    const [posts, setPosts] = useState([]);
    const [file, setFile] = useState(null);
    

    useEffect(() => {
        
    },[])

    function criarConta(e){
        e.preventDefault();
        let email = document.getElementById('email-cadastro').value;
        let username = document.getElementById('username-cadastro').value;
        let senha = document.getElementById('senha-cadastro').value;

        auth.createUserWithEmailAndPassword(email,senha)
        .then((authUser)=>{
            authUser.user.updateProfile({
                displayName:username
            })
            alert('Conta criada com sucesso.');
            let modal = document.querySelector('.modalCriarConta');

            modal.style.display ="none";
        }).catch((err)=>{
            alert(err.message);
        });

    }

    function entrar(e){
        e.preventDefault();
        let email = document.getElementById('email-login').value;
        let senha = document.getElementById('senha-login').value;

        auth.signInWithEmailAndPassword(email,senha)
        .then((auth)=>{
            props.setUser(auth.user.displayName);
            //alert('Logado com sucesso.');
            window.location.href ="/";
        }).catch((err)=>{
            alert(err.message);
        })
    }

    function abrirModalCriarConta(e){
        e.preventDefault();
        
        let modal = document.querySelector('.modalCriarConta');

        modal.style.display = "block";
    }

    function fecharModalCriar(){ 
        let modal = document.querySelector('.modalCriarConta');

        modal.style.display ="none";

    }

    function sair(e) {
        e.preventDefault();
        auth.signOut().then(function(val){
            props.setUser(null);
            window.location.href ="/";
        })
    }

    function abrirModalUpload(e){
        let modal = document.querySelector('.modalUpload');

        modal.style.display ="block";
    }

    function fecharModalUpload(){ 
        let modal = document.querySelector('.modalUpload');

        modal.style.display ="none";
    }

    

    function uploadPost(e){ 
        e.preventDefault();
        let tituloPost = document.getElementById('titulo-upload').value;
        const uploadTask = storage.ref(`images/${file.name}`).put(file);
        

        uploadTask.on("state_changed", function(snapshot){
            const progress = Math.round(snapshot.bytesTransferred/snapshot.totalBytes) * 100;
            setProgress(progress);
        }, function(error){

        }, function(){

            storage.ref("images").child(file.name).getDownloadURL()
            .then(function(url){
                db.collection('posts').add({
                    titulo: tituloPost,
                    image: url,
                    userName: props.user,
                    timestamp: firebase.firestore.FieldValue.serverTimestamp()
                })
                

                setProgress(0);
                setFile(null);
                
                

                document.getElementById('form-upload').reset();
                fecharModalUpload();
            })

        }
        )
    }
    
    

return (

    <div className="header">
        
                <div className="modalCriarConta">
                    <div className="formCriarConta">
                        <div onClick={()=>fecharModalCriar()} className="close-modal-criar">x</div>
                        <img src="https://i.postimg.cc/brMDPTCK/logocnoot.png"/>
                        <h3>Cadastre-se para ver tudo o que <br/> seus amigos compartilham.</h3>
                        <form onSubmit={(e)=>criarConta(e)}>
                            <input id="email-cadastro" type="text" placeholder="Seu melhor email"/>
                            <input id="username-cadastro" type="text" placeholder="Nome de usuário"/>
                            <input id="senha-cadastro" type="password" placeholder="Senha"/>
                            <input type="submit" value="Cadastre-se"/>
                        </form>
                    </div>
                </div>

                <div className="modalUpload">
                    <div className="formUpload">
                        <div onClick={()=>fecharModalUpload()} className="close-modal-criar">X</div>
                        <h3>Criação de noot</h3>
                        <form id="form-upload" onSubmit={(e)=>uploadPost(e)}>
                            <input id="titulo-upload" type="text" placeholder="Crie uma incrível noot para sua comunidade..."/>
                            <label>
                            <a><i id="addfile" class="fas fa-paperclip"><input id="file-log" onChange={(e)=>setFile(e.target.files[0])} type="file"/></i></a>
                            </label> 
                            {/* <a><i id="addemoji" class="far fa-smile-wink"></i><input id="emoji-log" type="button" placeholder=""/></a> */}
                            <input type="submit" value="Enviar seu Noot"/>
                        </form>
                    </div>
                </div>

                <div className="center">
                    <div className="header__logo">
                        <a href=""><img src="https://i.postimg.cc/brMDPTCK/logocnoot.png" /></a>
                    </div>
                    
                    {
                    (props.user)?
                    <div className="header__logInfo">
                        <span className="name-create">Olá, <b>{props.user}</b></span>
                        <a id="message-create" href="#"><i class="fas fa-inbox"></i></a>
                        <a className="create-create" onClick={(e)=>abrirModalUpload(e)} href="#"><i class="far fa-plus-square"></i></a>
                        <a id="perfil" href="/perfil">{/* <img src="#"/> */}<i class="fas fa-user-circle"></i></a>
                        <a className="sair-create" onClick={(e)=>sair(e)} href="#"><i class="fas fa-power-off"></i></a>
                    
                        
                    </div>
                    :
                    <div className="header__loginForm">
                        <form onSubmit={(e)=>entrar(e)}>
                            <input id="email-login" type="text" placeholder="E-mail"/>
                            <input id="senha-login" type="password" placeholder="Senha"/>
                            <input type="submit" name="acao" value="Entrar"/>
                        </form>
                        <div className="btn__criarConta">
                            <a onClick={(e)=>abrirModalCriarConta(e)} href="#">Cadastre-se</a>
                        </div>
                    </div>
                    }
                
            </div>
                    
            
    </div>
        

    )
             
}

export default Header;